<style lang="less">
    /**
    样式定义
     */
</style>
<template>
    <div>
        <card style="">
            <Tabs v-model="current" @on-click="changeType" :animated="false" style="min-height: 400px">
                <TabPane label="班级信息" name="info">
                    <basic ref="basic" :detailForm="detailForm" :clazzId="clazzId"></basic>
                </TabPane>
                <TabPane :label="studentListLabel" name="students">
                    <students ref="students" :detailForm="detailForm" :clazzId="clazzId" @changeStudentNum="changeStudentNum"></students>
                </TabPane>
                <TabPane label="排课计划" name="schedule">
                    <schedule ref="schedule" :detailForm="detailForm" :clazzId="clazzId"></schedule>
                </TabPane>
                <TabPane label="上课记录" name="classlog">
                    <classlog ref="classlog" :detailForm="detailForm" :clazzId="clazzId"></classlog>
                </TabPane>
            </Tabs>
        </card>
    </div>
</template>

<script>
  import basic from './basic'
  import students from './students'
  import schedule from './schedule'
  import classlog from './classlog'


  export default {
    name: 'clazz_detail',
    components: {
      basic,
      students,
      schedule,
      classlog
    },
    data () {
      return {
        current: 'info',
        studentNum:0,
        detailForm:{},
        cancelFormValidate:{
          reason: [
            { required: true, message: '请输入取消原因', trigger: 'blur' }
          ],
        },
      }
    },
    created(){},
    mounted(){
      this.showInfo()
      this.$refs.students.getStudents()
    },
    activated(){},//页面有缓存的情况下，重新打开时触发的方法
    methods: {
      changeStudentNum:function(num){
        this.studentNum = num;
      },
      showInfo: function () {
        this.$api.clazz.getInfo({id: this.clazzId}).then(res => {
          if (res.state == "ok") {
            this.detailForm = res.data;
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      changeType(newVal, oldVal) {
        if (newVal != 'info' && newVal != 'students' && newVal != 'schedule' && newVal != 'classlog' &&  newVal.name != 'clazz_detail' ){
            return;
        }
        this.$nextTick(() => {
          switch (this.current) {
            case"info":
              if (this.clazzId != null) {
                this.showInfo();
              }
              break;
            case"students":
              if (this.clazzId != null) {
                this.$refs.students.getStudents()
              }
              break;
            case"schedule":
              if (this.clazzId != null) {
                this.$refs.schedule.getSchedules()
              }
              break;
            case"classlog":
              if (this.clazzId != null) {
                this.$refs.classlog.getList()
              }
              break;
            default:
              break;
          }
        })
      },

    },
    computed: {
      clazzId(){
        return parseInt(this.$route.query.id);
      },
      studentListLabel(){
        // return '学员列表'+(this.students.data.length>0?('('+this.students.data.length+')'):'')
        return '学员列表'+(this.studentNum>0?('('+this.studentNum+')'):'')

      },
    },
    filters:{
    },
    watch: {
      '$route': 'changeType'
    }
  }
</script>
